import { PicklistItem } from "@shared/mirage/PickLists/PicklistFile";
import React, { createContext, useContext, ReactNode } from "react";

export interface PicklistContextType {
    getPicklistItems: (picklistName: string) => PicklistItem[];
}

const defaultContext: PicklistContextType = {
    getPicklistItems: () => [],
};

export const PicklistContext = createContext<PicklistContextType>(defaultContext);

export const usePicklist = (): PicklistContextType => useContext(PicklistContext);

interface PicklistProviderProps {
    children: ReactNode;
    picklistProvider: PicklistContextType;
}

export const PicklistProvider: React.FC<PicklistProviderProps> = ({ children, picklistProvider }) => {
    return <PicklistContext.Provider value={picklistProvider}>{children}</PicklistContext.Provider>;
};
